// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"style_sectionHeading__ifB4Z","sectionDivider":"style_sectionDivider__xz4tf"};